export default __webpack_public_path__ + "static/media/ERC721.5499a9f5.mp4";